import { useCallback, useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'

import PanelRoutes from './PanelRoutes'
import { PANEL_ROUTES } from './routes'

function HomeBreakerPanels() {
  const { path, url } = useRouteMatch()

  const buildPanelRoutePath = useCallback(
    (routePath: string) => `${path}/${routePath}`,
    [path]
  )

  const buildPanelsLinkPath = useCallback(
    (path: string) => `${url}/${path}`,
    [url]
  )

  const routes = useMemo(
    () =>
      PANEL_ROUTES.map(({ path, component }) => ({
        path: buildPanelRoutePath(path),
        component,
      })),
    [buildPanelRoutePath]
  )

  const defaultRoute = buildPanelsLinkPath(PANEL_ROUTES[0].path)

  return <PanelRoutes defaultRoute={defaultRoute} panelRoutes={routes} />
}

export default HomeBreakerPanels
